<template>
  <tag-selector v-if="showTagSelector" :active-tag="activeTag" :clearable="!isPresenter" @update="onTagUpdate" />
</template>

<script>
import TagSelector from "@/components/ui/tagselector/TagSelector.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DashboardTagSelector",
  components: { TagSelector },
  data() {
    return {
      activeTag: null,
    };
  },
  watch: {
    activeProductionUnitTags() {
      this.activeTag = this.activeProductionUnitTags.length > 0 ? this.activeProductionUnitTags[0] : null;
    },
  },
  computed: {
    ...mapGetters("dashboard", ["activeProductionUnitTags"]),
    ...mapGetters("navigation", ["factoryTags", "isLiveData"]),
    ...mapGetters("user", ["isPresenter"]),
    showTagSelector() {
      if (this.isPresenter) {
        return this.factoryTags.length > 0 && this.isLiveData && this.activeTag;
      }
      return this.factoryTags.length > 0 && this.isLiveData;
    },
  },
  methods: {
    ...mapActions("dashboard", ["setActiveProductionUnitTag", "removeActiveProductionUnitTag"]),
    onTagUpdate(newTagId) {
      if (newTagId) {
        this.setActiveProductionUnitTag(newTagId);
      } else {
        this.removeActiveProductionUnitTag(this.activeTag.id);
      }
    },
  },
};
</script>
